document.addEventListener('DOMContentLoaded', function () {
  const slides = document.querySelectorAll('.carousel-slide');
  if (slides.length > 0) {
    const nextBtn = document.querySelector('.carousel-next');
    const prevBtn = document.querySelector('.carousel-prev');
    let currentSlide = 0;
    let slideInterval;

    function showSlide(index) {
      slides[currentSlide].classList.remove('active');
      currentSlide = (index + slides.length) % slides.length;
      slides[currentSlide].classList.add('active');
    }

    function nextSlide() {
      showSlide(currentSlide + 1);
    }

    function prevSlide() {
      showSlide(currentSlide - 1);
    }

    function startSlideshow() {
      slideInterval = setInterval(nextSlide, 5000); // Change image every 5 seconds
    }

    function resetSlideshow() {
      clearInterval(slideInterval);
      startSlideshow();
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        nextSlide();
        resetSlideshow();
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        prevSlide();
        resetSlideshow();
      });
    }

    // Initialize
    slides[0].classList.add('active');
    startSlideshow();
  }
  // Quantity Selectors
  const quantityWrappers = document.querySelectorAll('.quantity-wrapper');
  quantityWrappers.forEach(wrapper => {
    const btnMinus = wrapper.querySelector('.qty-minus');
    const btnPlus = wrapper.querySelector('.qty-plus');
    const input = wrapper.querySelector('input[type="number"]');

    if (btnMinus && btnPlus && input) {
      btnMinus.addEventListener('click', (e) => {
        e.preventDefault();
        let val = parseInt(input.value) || 0;
        let min = parseInt(input.min);
        if (isNaN(min)) min = 0;
        if (val > min) {
          input.value = val - 1;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
      btnPlus.addEventListener('click', (e) => {
        e.preventDefault();
        let val = parseInt(input.value) || 0;
        input.value = val + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  });

  // Real-time Cart Updates
  const formatMoney = (cents) => {
    return '₪' + (cents / 100).toFixed(2);
  };

  const cartQuantityInputs = document.querySelectorAll('.cart-quantity-input');
  cartQuantityInputs.forEach(input => {
    input.addEventListener('change', function () {
      const line = this.getAttribute('data-line');
      const quantity = this.value;
      const cartTable = document.querySelector('.cart-table-wrapper');

      if (cartTable) cartTable.style.opacity = '0.5';

      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          line: line,
          quantity: quantity
        })
      })
        .then(response => response.json())
        .then(state => {
          location.reload();
        })
        .catch(error => {
          console.error('Error updating cart:', error);
          if (cartTable) cartTable.style.opacity = '1';
        });
    });
  });

  // Product Page - Image Gallery
  const productGrids = document.querySelectorAll('.product-page-grid');
  productGrids.forEach(grid => {
    const thumbnails = grid.querySelectorAll('.product-thumbnail');
    const mainImage = grid.querySelector('.product-main-image');

    if (thumbnails.length > 0 && mainImage) {
      thumbnails.forEach(function (thumbnail) {
        thumbnail.addEventListener('click', function () {
          const newImageSrc = this.getAttribute('data-main-image');
          if (newImageSrc) {
            mainImage.setAttribute('src', newImageSrc);
          }
        });
      });
    }
  });

  // Product Page - Copy Link
  const copyBtn = document.getElementById('CopyLinkBtn');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      const urlToCopy = this.getAttribute('data-url');
      navigator.clipboard.writeText(urlToCopy).then(function () {
        const msg = document.getElementById('CopySuccessMsg');
        if (msg) {
          msg.style.display = 'inline-block';
          setTimeout(() => {
            msg.style.display = 'none';
          }, 2000);
        }
      }).catch(function (err) {
        console.error('Could not copy text: ', err);
      });
    });
  }

  // Drawer Menu Logic
  const drawerOpenBtn = document.getElementById('DrawerOpen');
  const drawerCloseBtn = document.getElementById('DrawerClose');
  const menuDrawer = document.getElementById('MenuDrawer');
  const drawerOverlay = document.getElementById('DrawerOverlay');

  function openDrawer() {
    if (menuDrawer && drawerOverlay) {
      menuDrawer.classList.add('is-open');
      drawerOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeDrawer() {
    if (menuDrawer && drawerOverlay) {
      menuDrawer.classList.remove('is-open');
      drawerOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
    }
  }

  if (drawerOpenBtn) {
    drawerOpenBtn.addEventListener('click', openDrawer);
  }

  if (drawerCloseBtn) {
    drawerCloseBtn.addEventListener('click', closeDrawer);
  }

  if (drawerOverlay) {
    drawerOverlay.addEventListener('click', closeDrawer);
  }
});

// ==========================================
// Color Picker Logic for Product Cards
// ==========================================
document.addEventListener('click', function (e) {
  if (e.target && e.target.classList.contains('color-dot-clickable')) {
    const dot = e.target;
    const productId = dot.getAttribute('data-product-id');
    const variantId = dot.getAttribute('data-variant-id');
    const imageUrl = dot.getAttribute('data-image');

    // Update active class
    const siblings = dot.parentElement.querySelectorAll('.color-dot-clickable');
    siblings.forEach(s => s.classList.remove('active'));
    dot.classList.add('active');

    // Update hidden variant input
    if (productId && variantId) {
      const input = document.querySelector('.product-variant-id-' + productId);
      if (input) {
        input.value = variantId;
      }
    }

    // Update product image if a specific variant image exists
    if (productId && imageUrl) {
      const img = document.querySelector('.product-image-' + productId);
      if (img) {
        img.src = imageUrl;
      }
    }
  }
});
